import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserService } from 'src/app/security/services/user.service';

@UntilDestroy()
@Component({
  selector: 'app-global-header',
  standalone: false,
  templateUrl: './global-header.component.html',
})
export class GlobalHeaderComponent {
  userDisplayName: string | undefined;
  constructor(private userService: UserService) {
    this.userService
      .getCurrentUserObservable()
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.userDisplayName = user.name;
      });
  }
}
